// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1EvtN","colMaxWidth":"Table_colMaxWidth__tUlX7"};